import { TFormalOffer } from './formalOffers.types';

/**
 * Checks if an offer is an interest-only offer
 *
 * @param formalOffer A formal offer object.
 * @returns `true` if the formal offer has interest_only_repayments and interest_only_repayments is greater than 0.
 */
export const getIsInterestOnlyOffer = (formal_offer: TFormalOffer): boolean => {
    return Boolean(
        formal_offer.interest_only_repayments &&
        formal_offer.interest_only_repayments > 0
    );
};
